import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {PageTitleLayoutComponent} from "../../../components/page-title-layout/page-title-layout.component";
import {CustomFormComponent} from "../../../components/custom-form/custom-form.component";
import {FormInputsComponent} from "../../../components/form-inputs/form-inputs.component";
import {TextInputComponent} from "../../../components/text-input/text-input.component";
import {FormBuilder, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import { QuestionService } from '../../../services/question.service';
import {FloatLabel} from "primeng/floatlabel";
import {Textarea} from "primeng/textarea";
import {MessageService} from "primeng/api";
import {switchMap, tap} from "rxjs";
import {Router} from "@angular/router";
import {emailValidationErrorMessage, emailValidators} from "../../../validators";

@Component({
  selector: 'homey-contact-page',
  imports: [
    PageTitleLayoutComponent,
    CustomFormComponent,
    FormInputsComponent,
    TextInputComponent,
    FloatLabel,
    FormsModule,
    Textarea,
    ReactiveFormsModule
  ],
  templateUrl: './contact-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactPageComponent {
  private readonly fb = inject(FormBuilder);
  protected readonly emailValidationErrorMessage = emailValidationErrorMessage;

  protected readonly form = this.fb.group({
    name: this.fb.nonNullable.control('', [Validators.required]),
    // Optional; a typo'd domain (name@gmail) would leave support's reply nowhere to go.
    email: this.fb.nonNullable.control('', emailValidators),
    message: this.fb.nonNullable.control('', [Validators.required])
  });
  private readonly questionService = inject(QuestionService);
  private readonly router = inject(Router);
  private readonly messageService = inject(MessageService);

  submit = (data: {
    name: string;
    email: string;
    message: string;
  }) => {
    return this.questionService.createQuestion({
      name: data.name,
      email: data.email,
      message: data.message
    }).pipe(
      tap(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Message sent',
          detail: 'We will get back to you soon'
        });
      }),
      switchMap(() => this.router.navigateByUrl('/'))
    )
  };
}
